<template>
  <div :class="{ scrolled: !atTop }">
    <slot />
  </div>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      atTop: true,
      scrollPos: 0,
      scrolled: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll')
  },
  methods: {
    handleScroll() {
      var sp = window.scrollY || window.scrollTop
      if (sp == undefined || sp < 150) {
        this.atTop = true
        eventBus.$emit('nav:bar:scrolled', false)
      } else {
        this.atTop = false
        eventBus.$emit('nav:bar:scrolled', true)
      }
    },
  },
}
</script>
